import { Helper } from "../util/helper.js";
import { IndividualDataHelper } from "../util/individualDataHelper.js";
import { createHtppServiceInstance, HTTPService } from "../util/httpManager.js";

import { ToolBarInGridButtonType } from "./toolBar.js";
import { AddressSearchColumn, BaseColumn, CheckBoxColumn, ComponentType, ContactSearchColumn, DataEntryColumn, DropDownColumn, EditableGrid, field, InfoItemRefresher, InGridButtonClickParams, InGridToolBarButton, MachineSearchColumn, MultiColumn, ProjectSearchColumn, ResourceSearchColumn, Schema, TicketSearchColumn, ValidationResultType } from "./editableGrid/editableGrid.js";
import { Config } from "../config/config.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import { ValidationBuilder } from "./editableGrid/validationBuilder.js";
import React from "react";

const additonalDataSuffix = "_additional_data";
type IndividualNDataInlineProps = {
    type: string;
    keyVal1: string;
    keyVal2: string;
    onChange: any;
    getMenuItemReference(): InfoItemRefresher;
    recordRight: { CanWrite: boolean };
};

export default class IndividualNDataInline extends React.Component<IndividualNDataInlineProps, { gridData: any[] }>{
    private _icuh = Helper;
    private _indivHelper = IndividualDataHelper.create();
    private _translations: StringKeyDictionary<string>;
    private _gridColumns: BaseColumn[];
    private _schema: Schema;
    private editableGridRef: EditableGrid;

    private _config = {
        fieldsMetadata: [],
        categoryMetadata: [],
        editWindowCache: {
            metadata: {
                tabs: []
            },
            dataSources: {},
            fieldsListObject: {},
            fieldsMetaData: [],
            keys: {
                id1Name: null,
                id2Name: null
            }
        },
        fieldsListObject: {}
    };

    private _dataUrl: string = null;

    constructor(props) {
        super(props)
        this.state = { gridData: null };
        this._initApp();
    }

    private _convertToGridItem(individualArray) {
        const result = {};

        for (var i = 0; i < individualArray.length; i++) {
            result[individualArray[i].Name] = individualArray[i].UnmodifiedValue || individualArray[i].Value;

            if (individualArray[i].ValueObject) {
                result[individualArray[i].Name + additonalDataSuffix] = individualArray[i].ValueObject;
            }
        }
        return result;
    }

    private resolveAdditionalData = async (pkValue: string, fieldName: string) => {
        this._dataUrl = this.props.type + `IndividualN/ResolveAdditionalData?pkValue=${encodeURIComponent(pkValue)}&fieldName=${encodeURIComponent(fieldName)}`;
        const result = await createHtppServiceInstance().noBusyIndicator().get(this._dataUrl);
        return result.Data;
    }

    private loadGridData = () => {
        this._dataUrl = this.props.type + 'IndividualN/GetTableData?id1=' + encodeURIComponent(this.props.keyVal1)
            + (this._icuh.hasValue(this.props.keyVal2) ? '&id2=' + encodeURIComponent(this.props.keyVal2) : "");
        return HTTPService.get(this._dataUrl);
    }

    private _initApp = async () => {

        const result = await Promise.all([
            this.loadGridData(),
            this._icuh.getTranslations(["Standard.Msg.Loeschen", "Standard.Msg.SpeichernFehler", "Standard.Msg.SpeichernErfolgreich",
                "Standard.OK", "Standard.Neu", "Standard.Speichern", "Standard.CloseBtn", "WebSMS.Additional.NData",
                "WebSMS.Additional.EditNData", "Standard.BitteWählen", "Standard.Editieren", "Standard.Loeschen",
                "Adresse.AdresseSuchen", "Maschine.Maschinensuche", "Projekt.Projektsuche", "Ressource.Ressourcensuche",
                "Ansprechpartner.Ansprechpartnersuche", "WebSMS.Title.ProcedureSearch", "MonitorBaum.NeuLaden", "Standard.PflichtfeldAllgemein"])
        ])
        this._translations = result[1].Data;
        const _data = result[0];

        this._config.fieldsMetadata = _data.Data.metadata;
        this._config.categoryMetadata = _data.Data.categoryMetadata;
        const tmpEditMetadata = this._indivHelper.createMetadata(this._config, this._translations["WebSMS.Additional.NData"], "metadata", false, this._translations, null, true);
        this._config.editWindowCache.metadata = tmpEditMetadata.gui;
        this._config.editWindowCache.dataSources = tmpEditMetadata.dataSources;
        this._config.fieldsListObject = this._indivHelper.getFieldsList(this._config, tmpEditMetadata.gui);
        this._config.editWindowCache.fieldsListObject = this._config.fieldsListObject;
        this._config.editWindowCache.fieldsMetaData = this._config.fieldsMetadata;
        this._config.editWindowCache.keys = _data.Data.keys;

        const gridData = [];
        for (let i = 0; i < _data.Data.data.length; i++) {
            gridData.push(this._convertToGridItem(_data.Data.data[i]));
        }

        const gridSettings = this.initGridSettings();
        this._gridColumns = gridSettings.Columns;
        this._schema = gridSettings.Schema;

        this.setState({ gridData: gridData });
    }

    initGridSettings = (): { Schema: Schema, Columns: BaseColumn[] } => {

        const columns: BaseColumn[] = [];
        const schema = new Schema();
        schema.Id = "isguid";
        schema.fields["isguid"] = new field("string");

        if (Config.settings.useIndCategories) {
            for (let categoryMetaData of this._config.categoryMetadata) {
                let multiColumn = this.getMultiColumn(categoryMetaData);
                columns.push(multiColumn);

                for (let columnMetaData of categoryMetaData.InputFields) {
                    schema.fields[columnMetaData.Name] = new field(this._convertTypeForGrid(columnMetaData.Type));
                }
            }
        } else {
            for (let i = 0; i < this._config.fieldsMetadata.length; i++) {
                const metadata = this._config.fieldsMetadata[i];
                if (!metadata.IsPrimaryKey && metadata.Name != "isguid") {
                    let column = this.getColumn(metadata);
                    schema.fields[metadata.Name] = new field(this._convertTypeForGrid(metadata.Type));
                    columns.push(column);
                }
            }
        }

        return { Columns: columns, Schema: schema };
    }

    private getColumn = (metadata) => {
        let column: DataEntryColumn = new DataEntryColumn();

        if (metadata.ComponentType == ComponentType.MachineSearch) {
            const machineSearchColumn = new MachineSearchColumn();
            machineSearchColumn.template = metadata.KendoTemplate;
            column = machineSearchColumn;
        }
        else if (metadata.ComponentType == ComponentType.AddressSearch) {
            const addresssearchColumn = new AddressSearchColumn();
            addresssearchColumn.template = metadata.KendoTemplate;
            column = addresssearchColumn;
        }
        else if (metadata.ComponentType == ComponentType.ProjectSearch) {
            const projectsearchColumn = new ProjectSearchColumn();
            projectsearchColumn.template = metadata.KendoTemplate;
            column = projectsearchColumn;
        }
        else if (metadata.ComponentType == ComponentType.TicketSearch) {
            const ticketSearchColumn = new TicketSearchColumn();
            ticketSearchColumn.template = metadata.KendoTemplate;
            column = ticketSearchColumn;
        }
        else if (metadata.ComponentType == ComponentType.ResourceSearch) {
            const resourceSearchColumn = new ResourceSearchColumn();
            resourceSearchColumn.template = metadata.KendoTemplate;
            column = resourceSearchColumn;
        }
        else if (metadata.ComponentType == ComponentType.ContactSearch) {
            const contactSearchColumn = new ContactSearchColumn();
            contactSearchColumn.template = metadata.KendoTemplate;
            column = contactSearchColumn;
        }
        else {
            if (metadata.Type == 7 || metadata.Type == 6) {
                const dropDownColumn = new DropDownColumn();
                dropDownColumn.choices = metadata.Value.Choices.map((i) => { return typeof i !== "object" ? { Value: i, Text: i } : { Value: i.Item1, Text: i.Item2 } });
                column = dropDownColumn;
            }
            else if (metadata.Type == 4) {
                const checkboxColumn = new CheckBoxColumn();
                column = checkboxColumn;
            }
        }
        if (metadata.Type == 5) {
            if (metadata.Display === 1) {
                column.format = "{0:g}";
            } else {
                column.format = "{0:d}"
            }
        }

        column.field = metadata.Name;
        column.title = metadata.DisplayName;
        column.editable = () => !metadata.IsReadOnly;
        column.defaultValue = () => metadata.DefaultValue;
        column.required = () => metadata.IsRequired;

        return column;
    }

    private getMultiColumn(metaData) {
        let multiColumn = new MultiColumn();
        multiColumn.title = metaData.DisplayName;
        multiColumn.field = metaData.Id;
        multiColumn.columns = [];
        for (let columnMetaData of metaData.InputFields) {
            let column = this.getColumn(columnMetaData);
            multiColumn.columns.push(column);
        }
        return multiColumn;
    }

    private _convertTypeForGrid(type) {
        switch (type) {
            case 1://numeric
            case 2://currency
            case 3://intnumeric
                return "number";
            case 4://checkbox
                return "boolean";
            case 5://datetimepicker
                return "date";
            case 0://textbox
            case 6://combobox
            case 7://multilangcombobox
            case 8://multilinetext
            default:
                return "string";
        }
    }

    handleValidationRequest = (columns, dataItem) => {
        let validationBuilder = new ValidationBuilder();
        for (var i of this._config.editWindowCache.fieldsMetaData) {
            if (i.IsRequired && !Helper.hasValue(dataItem[i.Name])) {
                validationBuilder.addError(i.IsRequired && !Helper.hasValue(dataItem[i.Name]), this._translations["Standard.PflichtfeldAllgemein"] + ' ' + i.DisplayName + ' ');
            }
        }
        return validationBuilder.build();
    }

    handleDataChanged = (action, fieldName, changedItems) => {
        this.props.onChange && this.props.onChange();
    }

    prepareItemForUpdate = (item) => {
        const values = this._indivHelper.convertToIndividualItem(item, this._config.fieldsMetadata).filter(t => t.Identifier !== this._config.editWindowCache.keys.id1Name && t.Identifier !== this._config.editWindowCache.keys.id2Name);
        return values;
    }

    canSave = () => {
        const dataSource = this.editableGridRef.getDataSource();
        const errors = dataSource.data().filter((i) => { return this.handleValidationRequest([], i) !== null });
        return errors.length === 0;
    }

    save = async () => {

        const dataSource = this.editableGridRef.getDataSource();
        const deleted: any[] = dataSource["destroyed"]();
        const changed: any[] = dataSource["updated"]().filter(x => !x.IsNew);
        const created: any[] = (dataSource.data() as any).filter(x => x.IsNew);
        const url = this.props.type + 'IndividualN/BatchUpdate';
        const toSend = {
            PK: this.props.keyVal1,
            PosToDelete: deleted.map((i) => i[this._config.editWindowCache.keys.id2Name]),
            ObjToUpdate: changed.map((i) => { return { Pos: i[this._config.editWindowCache.keys.id2Name], Values: this.prepareItemForUpdate(i) } }),
            ObjToCreate: created.map((i) => { return this.prepareItemForUpdate(i) }),
        };

        await HTTPService.post(url, toSend);
        const result = await Promise.all([this.loadGridData()]);
        const gridData = [];
        for (let i = 0; i < result[0].Data.data.length; i++) {
            gridData.push(this._convertToGridItem(result[0].Data.data[i]));
        }
        this.setState({ gridData: gridData });
        this.editableGridRef.getDataSource().sync();
    }

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let newItem = {
                    [this._schema.Id]: kendo.guid(),
                    IsNew: true
                };
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(false);
                break;
        }
    }

    render() {
        let content = null;
        if (this.state.gridData) {
            const buttons: Array<InGridToolBarButton> = [];
            buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
            buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit" });
            buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });

            let id = "indData" + this.props.type;
            content = <>
                <EditableGrid
                    id={id}
                    ref={(e) => { this.editableGridRef = e }}
                    editable={this.props.recordRight.CanWrite}
                    schema={this._schema}
                    columns={this._gridColumns}
                    data={this.state.gridData}
                    resolveAdditionalData={this.resolveAdditionalData}
                    onRequestItemValidation={this.handleValidationRequest}
                    onDataChanged={this.handleDataChanged}
                    onSelectionChange={() => this.setState({})}
                    buttons={buttons}
                    onButtonClick={this.handleButtonClick}
                    gridDetails={{
                        useFeature: true
                    }}
                    useFloatingButtons={true}
                />
            </>
        }


        return (<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {content}
        </div>);
    }
};
